import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardNavbar = _resolveComponent("DashboardNavbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_LightFooter = _resolveComponent("LightFooter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DashboardNavbar),
    _createVNode(_component_router_view),
    _createVNode(_component_LightFooter)
  ]))
}